import React from "react";
import { withRouter, Switch, Route, Redirect, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useAuth } from "@syos-music/auth";

import { Button } from "@mui/material";

import Layout from "components/common/Layout";

function UserErrorPage() {
  return (
    <>
      <Layout.Error>Vous ne faites pas partie de la Syos team !</Layout.Error>
      <Button component={Link} to="/user/logout" sx={{ alignSelf: "center" }}>
        Déconnexion
      </Button>
    </>
  );
}

function Router({ match, location: { pathname } }) {
  const { isLoggedIn, hasRole } = useAuth();
  const location = useLocation();
  const redirect = encodeURIComponent(
    location.pathname + location.search + location.hash
  );

  if (pathname.endsWith("/") && pathname !== match.url)
    return <Redirect to={pathname.substr(0, pathname.length - 1)} />;

  return (
    <Switch>
      <Route path="/user/login" component={require("./user/login").default} />
      <Route path="/user/logout" component={require("./user/logout").default} />
      {!isLoggedIn && <Redirect to={`/user/login?redirect=${redirect}`} />}
      {!hasRole("SYOS_MEMBER") && <Route component={UserErrorPage} />}

      <Route path="/" exact component={require("./index").default} />
      <Route path="/user" exact component={require("./user").default} />

      <Route path="/orders" exact component={require("./orders").default} />
      <Route
        path="/orders/:orderId"
        component={require("./orders/[orderId]").default}
      />

      <Route path="/barcodes" component={require("./barcodes").default} />

      <Route path="/inventory" component={require("./inventory").default} />

      <Route exact path="/billing" component={require("./billing").default} />
      <Route
        path="/billing/create-invoice"
        exact
        component={require("./billing/create-invoice").default}
      />

      <Route
        path="/discount-codes"
        component={require("./discount-codes").default}
      />

      <Route path="/articles" exact component={require("./articles").default} />
      <Route
        path="/articles/:articleId"
        component={require("./articles/[articleId]").default}
      />

      <Route
        path="/signature-mouthpieces"
        exact
        component={require("./signature-mouthpieces").default}
      />
      <Route
        path="/signature-mouthpieces/:signatureMouthpieceId"
        component={
          require("./signature-mouthpieces/[signatureMouthpieceId]").default
        }
      />

      <Route path="/reviews" component={require("./reviews").default} />

      <Route path="/entity-tags" component={require("./entity-tags").default} />

      <Route
        path="/mouthpieces/legacy/:legacyMouthpieceId"
        component={require("./mouthpieces/legacy/[legacyMouthpieceId]").default}
      />

      <Route path="/stats" component={require("./stats").default} />

      <Route exact path="/admin" component={require("./admin").default} />
      <Route
        exact
        path="/admin/users"
        component={require("./admin/users").default}
      />
      <Route
        exact
        path="/admin/users/:userId"
        component={require("./admin/users/[userId]").default}
      />
      <Route
        exact
        path="/admin/templates"
        component={require("./admin/templates").default}
      />
      <Route
        exact
        path="/admin/templates/:templateId"
        component={require("./admin/templates/[templateId]").default}
      />
      <Route
        exact
        path="/admin/order-states"
        component={require("./admin/order-states").default}
      />
      <Route
        exact
        path="/admin/order-states/:orderStateId"
        component={require("./admin/order-states/[orderStateId]").default}
      />
      <Route
        exact
        path="/admin/products"
        component={require("./admin/products").default}
      />
      <Route
        exact
        path="/admin/stocks"
        component={require("./admin/stocks").default}
      />
      <Route
        exact
        path="/admin/referral-rewards"
        component={require("./admin/referral-rewards").default}
      />
      <Route
        exact
        path="/admin/affiliations"
        component={require("./admin/affiliations").default}
      />

      <Route render={() => <Layout.NotFound />} />
    </Switch>
  );
}

export default withRouter(Router);
